
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.35 15.07a4.1 4.1 0 000-4.43 1 1 0 00.44-.31 1 1 0 00.21-.85A10.15 10.15 0 0012 2 10.13 10.13 0 002 9.48a1 1 0 00.18.85 1 1 0 00.44.31 4.1 4.1 0 000 4.43A1 1 0 002 16v2.73A3.27 3.27 0 005.27 22h13.46A3.28 3.28 0 0022 18.73V16a1 1 0 00-.65-.93zM12 4a8.31 8.31 0 017.62 4.71H4.39A8.28 8.28 0 0112 4zm8 14.73A1.27 1.27 0 0118.73 20H5.27A1.27 1.27 0 014 18.73V17h16zM17.85 15H6.14a2.15 2.15 0 010-4.29h11.71a2.15 2.15 0 110 4.29z"}})])
          )
        }
      }
    